import { useEffect, useState, type RefObject } from "react";

// Measures the actual laid-out height available to `elem`'s parent (minus its own
// vertical padding) instead of guessing, and keeps it in sync via ResizeObserver.
// Falls back to `fallback` until the parent has been measured (e.g. before first paint).
export const useAvailableHeight = (elem: RefObject<HTMLElement | null>, fallback = 400) => {
  const [height, setHeight] = useState(fallback);

  useEffect(() => {
    const parent = elem.current?.parentElement;
    if (!parent) return undefined;

    const measure = () => {
      const style = window.getComputedStyle(parent);
      const verticalPadding = parseFloat(style.paddingTop || "0") + parseFloat(style.paddingBottom || "0");
      const next = parent.getBoundingClientRect().height - verticalPadding;
      if (next > 0) setHeight(next);
    };

    measure();
    const observer = new window.ResizeObserver(measure);
    observer.observe(parent);
    return () => observer.disconnect();
  }, [elem]);

  return height;
};
